<template>
  <Message 
    :severity="severity"
    :variant="variant"
    :closable="closable"
    class="mb-4"
  >
    <slot />
  </Message>
</template>

<script>
import "@/assets/css/components/base/alert.css";
import Message from 'primevue/message';

export default {
  name: "TripleChoice",

  components: {Message},

  props: {
    closable: {
      type: Boolean,
      require: false,
    },
    variant: {
      type: String,
      default: "undefined",
    },
    severity: {
      type: String,
      default: "secondary",
    }
  },
};
</script>
